import HttpClient from '../../../services/http-client';
import { IDashboardResponse } from '../../../../model/apm/dashboard/response/dashboard-response';

const defaultPath = 'Dashboard';

// upcomingDays: janela (em dias) para aberturas de licitação e contratos a vencer; a API usa 30 por padrão
const get = async (upcomingDays?: number): Promise<IDashboardResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}`,
        params: { UpcomingDays: upcomingDays }
    }).then((response) => response.data);
};

const DashboardAppService = { get };
export default DashboardAppService;
